// extracted by mini-css-extract-plugin
module.exports = {"Header":"styles_Header__19PRZ","Header-content":"styles_Header-content__1TiyI","Header-logo":"styles_Header-logo__EGZ1_"};